import { render, staticRenderFns } from "./SharedProfile.vue?vue&type=template&id=6eb7f1f3&scoped=true&"
import script from "./SharedProfile.vue?vue&type=script&lang=js&"
export * from "./SharedProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb7f1f3",
  null
  
)

export default component.exports